import { export_jobs_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateExportJobsEnum = (enumValue: export_jobs_enum) => {
  switch (enumValue) {
    case export_jobs_enum.BUILDING_EXCEL_EXPORT:
      return <Trans i18nKey="Enum_ExportJobsEnum-BUILDING_EXCEL_EXPORT" />;
    case export_jobs_enum.SCENARIO_EXCEL_EXPORT:
      return <Trans i18nKey="Enum_ExportJobsEnum-SCENARIO_EXCEL_EXPORT" />;
    case export_jobs_enum.CONSUMPTION_GAP_ANALYSIS_EXCEL_EXPORT:
      return <Trans i18nKey="Enum_ExportJobsEnum-CONSUMPTION_GAP_ANALYSIS_EXCEL_EXPORT" />;
    case export_jobs_enum.CONSUMPTION_OVERVIEW_EXCEL_EXPORT:
      return <Trans i18nKey="Enum_ExportJobsEnum-CONSUMPTION_OVERVIEW_EXCEL_EXPORT" />;
    case export_jobs_enum.ESG_ANALYSIS_PDF_EXPORT:
      return <Trans i18nKey="Enum_ExportJobsEnum-ESG_ANALYSIS_PDF_EXPORT" />;
    case export_jobs_enum.ECONOMIC_UNIT_ESG_ANALYSIS_PDF_EXPORT:
      return <Trans i18nKey="Enum_ExportJobsEnum-ECONOMIC_UNIT_ESG_ANALYSIS_PDF_EXPORT" />;
    case export_jobs_enum.ACTION_PLAN_PDF_EXPORT:
      return <Trans i18nKey="Enum_ExportJobsEnum-ACTION_PLAN_PDF_EXPORT" />;
    case export_jobs_enum.REPORT_PDF_EXPORT:
      return <Trans i18nKey="Enum_ExportJobsEnum-REPORT_PDF_EXPORT" />;
    case export_jobs_enum.SUMMARY_ONE_PAGER_PDF_EXPORT:
      return <Trans i18nKey="Enum_ExportJobsEnum-SUMMARY_ONE_PAGER_PDF_EXPORT" />;
    case export_jobs_enum.BATCH_ESG_ANALYSIS_PDF_EXPORT:
      return <Trans i18nKey="Enum_ExportJobsEnum-BATCH_ESG_ANALYSIS_PDF_EXPORT" />;
    case export_jobs_enum.DRIVE_BULK_FILE_DOWNLOAD_ZIP:
      return <Trans i18nKey="Enum_ExportJobsEnum-DRIVE_BULK_FILE_DOWNLOAD_ZIP" />;
  }
};

export const translateExportJobsEnum_dynamic = (enumValue: export_jobs_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case export_jobs_enum.BUILDING_EXCEL_EXPORT:
      return t('Enum_ExportJobsEnum-BUILDING_EXCEL_EXPORT');
    case export_jobs_enum.SCENARIO_EXCEL_EXPORT:
      return t('Enum_ExportJobsEnum-SCENARIO_EXCEL_EXPORT');
    case export_jobs_enum.CONSUMPTION_GAP_ANALYSIS_EXCEL_EXPORT:
      return t('Enum_ExportJobsEnum-CONSUMPTION_GAP_ANALYSIS_EXCEL_EXPORT');
    case export_jobs_enum.CONSUMPTION_OVERVIEW_EXCEL_EXPORT:
      return t('Enum_ExportJobsEnum-CONSUMPTION_OVERVIEW_EXCEL_EXPORT');
    case export_jobs_enum.ESG_ANALYSIS_PDF_EXPORT:
      return t('Enum_ExportJobsEnum-ESG_ANALYSIS_PDF_EXPORT');
    case export_jobs_enum.ECONOMIC_UNIT_ESG_ANALYSIS_PDF_EXPORT:
      return t('Enum_ExportJobsEnum-ECONOMIC_UNIT_ESG_ANALYSIS_PDF_EXPORT');
    case export_jobs_enum.ACTION_PLAN_PDF_EXPORT:
      return t('Enum_ExportJobsEnum-ACTION_PLAN_PDF_EXPORT');
    case export_jobs_enum.REPORT_PDF_EXPORT:
      return t('Enum_ExportJobsEnum-REPORT_PDF_EXPORT');
    case export_jobs_enum.SUMMARY_ONE_PAGER_PDF_EXPORT:
      return t('Enum_ExportJobsEnum-SUMMARY_ONE_PAGER_PDF_EXPORT');
    case export_jobs_enum.BATCH_ESG_ANALYSIS_PDF_EXPORT:
      return t('Enum_ExportJobsEnum-BATCH_ESG_ANALYSIS_PDF_EXPORT');
    case export_jobs_enum.DRIVE_BULK_FILE_DOWNLOAD_ZIP:
      return t('Enum_ExportJobsEnum-DRIVE_BULK_FILE_DOWNLOAD_ZIP');
  }
};
